module.exports = __webpack_public_path__ + "media/styles/images/png/oval-white-e30cc918c6fa39f5230c00b46dfe1535.png";